export const zeroPad = (number: number, maxLength: number = 2): string => {
  return String(number).padStart(maxLength, '0');
};
